export const GENERIC_PROCEDURE_KIND_LABELS: { [key: string]: string } = {
  RED_PLATES: 'Placas Rojas',
  DUPLICATE: 'Duplicados',
  DOMAIN_RESERVATION: 'Reserva de dominio',
  SELL_NOTIFICATION: 'Notificación de venta',
  VEHICLE_REGISTRATION: 'Alta',
  VEHICLE_DEREGISTRATION: 'Baja',
  VEHICLE_IMPORT: 'Importación',
  ENVIRONMENTAL_BADGE: 'Distintivo ambiental',
  ISOLATED_SERVICE_TYPE_CHANGE: 'Cambio de servicio',
  GREEN_PLATES: 'Placa Verde',
  REINSTATEMENT: 'Rehabilitación',
  VEHICLE_ADDRESS_CHANGE: 'Cambio de domicilio',
  DRIVER_LICENSE_DUPLICATE: 'Duplicado carnet conducir',
  SINGLE_ADMINISTRATIVE_DOCUMENT: 'DUA',
  REFORM: 'Reforma',
};
